import { Box } from 'components/Box';
import { CmsApiRecommendedJobsBlockData } from 'modules/cms/api/types/CmsApiRecommendedJobs';
import { colors, gutterWidth } from 'theme';

import { CmsRecommendedJobsBlockContent } from './CmsRecommendedJobsBlockContent';

type Props = {
  data: CmsApiRecommendedJobsBlockData;
  fromCheckbox?: boolean;
  context?: 'standard' | 'amp';
};

export function CmsRecommendedJobsBlock({
  data,
  fromCheckbox,
  context,
}: Props) {
  const { layout, jobFunction } = data;

  const source = fromCheckbox
    ? 'RECOMMENDED_JOBS_CHECKBOX'
    : 'RECOMMENDED_JOBS_BLOCK';

  if (layout === 'SLIM') {
    // Additional gutter to position the arrows within the box
    const additionalXGutter = 76;

    return (
      <Box
        mx={[-gutterWidth / 2, null, -gutterWidth]}
        py={[gutterWidth / 2, null, gutterWidth]}
        px={[
          gutterWidth / 2,
          gutterWidth,
          gutterWidth + additionalXGutter,
          gutterWidth + additionalXGutter,
        ]}
        bg={colors.inputGrey}
        data-qa-id="recommended-jobs"
        data-qa-layout={layout}
        data-qa-source={source}
        data-qa-job-function={jobFunction}
      >
        <CmsRecommendedJobsBlockContent
          data={data}
          source={source}
          // @ts-expect-error TS(2322): Type '"standard" | "amp" | undefined' is not assig... Remove this comment to see the full error message
          context={context}
        />
      </Box>
    );
  }

  return (
    <Box
      data-qa-id="recommended-jobs"
      data-qa-layout={layout}
      data-qa-source={source}
      data-qa-job-function={jobFunction}
    >
      <CmsRecommendedJobsBlockContent
        data={data}
        source={source}
        // @ts-expect-error TS(2322): Type '"standard" | "amp" | undefined' is not assig... Remove this comment to see the full error message
        context={context}
      />
    </Box>
  );
}
